export const ADMIN_MELDINGEN_CACHE_TTL_MS = 30_000;

const snapshotsByScope = new Map();

export function getAdminMeldingenCacheScope({ branchId, isSuperAdmin } = {}) {
  if (isSuperAdmin) return 'superadmin:all-branches';
  const normalizedBranchId = String(branchId || '').trim();
  return normalizedBranchId ? `admin:branch:${normalizedBranchId}` : null;
}

export function readAdminMeldingenCache(scope, now = Date.now()) {
  if (!scope) return null;

  const snapshot = snapshotsByScope.get(scope);
  if (!snapshot || !snapshot.complete) return null;

  const age = now - snapshot.loadedAt;
  if (age < 0 || age > ADMIN_MELDINGEN_CACHE_TTL_MS) {
    snapshotsByScope.delete(scope);
    return null;
  }

  return { rows: snapshot.rows.slice(), loadedAt: snapshot.loadedAt };
}

export function writeAdminMeldingenCache(scope, rows, now = Date.now()) {
  if (!scope || !Array.isArray(rows)) return;
  snapshotsByScope.set(scope, { rows: rows.slice(), loadedAt: now, complete: true });
}

export function removeCachedAdminMelding(scope, meldingId, now = Date.now()) {
  if (!scope || !meldingId) return;
  const snapshot = snapshotsByScope.get(scope);
  if (!snapshot) return;
  snapshotsByScope.set(scope, {
    ...snapshot,
    rows: snapshot.rows.filter((melding) => melding.id !== meldingId),
    loadedAt: now,
  });
}

export function invalidateAdminMeldingenCache(scope) {
  if (scope) snapshotsByScope.delete(scope);
  else snapshotsByScope.clear();
}
